import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import EpicsIEEEPage from "./components/EpicsIEEEPage";
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Chatbot from './components/Chatbot/Chatbot';
import About from './components/About';
import Contact from './components/Contact';

import AuthLanding from './components/auth/AuthLanding';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import VerifyEmail from './components/auth/VerifyEmail';
import LoginSuccess from './components/auth/LoginSuccess';

import './App.css';
import Maintenance from './components/Maintenance';
import PolicyPage from './components/PolicyPage';
/* 🔹 Layout wrapper to control Navbar visibility */
function AppLayout() {
  const location = useLocation();

  // Pages where navbar should NOT appear
  const hideNavbarRoutes = [
    '/',
    '/login',
    '/register',
    '/verify-email',
    '/login-success',
    '/policy'
  ];

  const hideNavbar = hideNavbarRoutes.includes(location.pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}

      <Routes>
        {/* 🔐 AUTH LANDING */}
        <Route path="/" element={<AuthLanding />} />

        {/* 🔐 AUTH ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* ✅ LOGIN SUCCESS TRANSITION */}
        <Route path="/login-success" element={<LoginSuccess />} />
        <Route path="/epics" element={<EpicsIEEEPage />} />

        {/* 💬 CHATBOT */}
        <Route path="/chat" element={<Chatbot />} />

        {/* 📄 STATIC PAGES */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policy" element={<PolicyPage />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {

  // 🔒 MANUAL MAINTENANCE SWITCH
  const isMaintenance = false;   // change to true to enable maintenance mode

  if (isMaintenance) {
    return <Maintenance />;
  }

  return (
    <Router>
      <div className="App">
        <AppLayout />
      </div>
    </Router>
  );
}

export default App;
